module.exports = __webpack_public_path__ + "img/add_btn_icon491.a2c31aae.svg";